import { handleActions } from 'redux-actions'

import {
  setActionCounter,
  setAgencyCaseManagers,
  setBillingCodes,
  setCaregivers,
  setCaseManagers,
  setClinicians,
  setFacilities
} from 'src/store/modules/common/actionCreators'

const initialState = {
  billingCodes: [],
  facilities: [],
  caseManagers: [],
  clinicians: [],
  caregivers: [],
  agencyCaseManagers: [],
  actionCounter: []
}

export default handleActions(
  {
    [`${setBillingCodes}`](state: any, { payload: billingCodes }: any) {
      return {
        ...state,
        billingCodes
      }
    },

    [`${setFacilities}`](state: any, { payload: facilities }: any) {
      return {
        ...state,
        facilities
      }
    },

    [`${setCaseManagers}`](state: any, { payload: caseManagers }: any) {
      return {
        ...state,
        caseManagers
      }
    },

    [`${setClinicians}`](state: any, { payload: clinicians }: any) {
      return {
        ...state,
        clinicians
      }
    },

    [`${setCaregivers}`](state: any, { payload: caregivers }: any) {
      return {
        ...state,
        caregivers
      }
    },

    [`${setAgencyCaseManagers}`](
      state: any,
      { payload: agencyCaseManagers }: any
    ) {
      return {
        ...state,
        agencyCaseManagers
      }
    },

    [`${setActionCounter}`](state: any, { payload: actionCounter }: any) {
      return {
        ...state,
        actionCounter
      }
    }
  },
  initialState
)
